import styled from "styled-components";
import { theme } from "../../../../../../../constants/StyledComponents";

export const StyledManagePathsGradesPage = styled.div<{ $empty?: boolean }>`
  margin-top: 72px;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-top: 1px solid ${theme.colors.purple_2};
  width: ${({ $empty: empty }) => (empty ? "100%" : "calc(100vw - 416px)")};
  overflow: auto;

  & > div:first-child {
    overflow: auto;
    height: 100%;

    & > div {
      height: 100%;
    }

    & > .ant-spin-container {
      height: 100%;
    }
  }
`;

export const TableContainerManegePathGrade = styled.div<{ $isEmpty?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-x: auto;
  border-collapse: collapse;
  height: 100%;

  & .table-row {
    display: table-row;
  }

  & .table-row-general {
    display: flex;
    flex-direction: row;

    & > div:first-child {
      width: ${({ $isEmpty: isEmpty }) => (isEmpty ? "110px" : "auto")};
    }

    & > div:last-child {
      flex-grow: 1;
    }

    &:last-child {
      flex-grow: 1;
    }
  }

  & .table-cell-empty {
    border-right: 1px solid ${theme.colors.purple_2};
    border-bottom: 1px solid ${theme.colors.purple_2};
    padding: ${({ $isEmpty: isEmpty }) => (isEmpty ? "auto" : "0 191px")};
  }

  & .table-cell-paths {
    border-bottom: 1px solid ${theme.colors.purple_2};
  }

  & .table-cell-paths-grades {
    border-left: 1px solid ${theme.colors.purple_2};
  }
`;
